import { useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { AdminSidebar } from './AdminSidebar';
import { AdminHeader } from './AdminHeader';

export function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const isOrderDetailPage = /^\/orders\/[^/]+$/.test(location.pathname);
  const contentMaxWidth = isOrderDetailPage ? 'max-w-[996px]' : 'max-w-[1400px]';

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <AdminHeader onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto bg-[#F1F1F1] p-6">
          <div className={`mx-auto w-full ${contentMaxWidth}`}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
